import { render, staticRenderFns } from "./GridView.vue?vue&type=template&id=84bcde9e&scoped=true"
import script from "./GridView.vue?vue&type=script&lang=js"
export * from "./GridView.vue?vue&type=script&lang=js"
import style0 from "./GridView.vue?vue&type=style&index=0&id=84bcde9e&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84bcde9e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs_testing/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('84bcde9e')) {
      api.createRecord('84bcde9e', component.options)
    } else {
      api.reload('84bcde9e', component.options)
    }
    module.hot.accept("./GridView.vue?vue&type=template&id=84bcde9e&scoped=true", function () {
      api.rerender('84bcde9e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/modules/file-browser-product-selector/browser/views/GridView.vue"
export default component.exports